import Search from "../../services/Search.service";
import { push } from "connected-react-router";

export const SET_ACTIVE = 'SET_ACTIVE';
export const setActiveResultTab = (active: string) => {
  return {
    type: SET_ACTIVE,
    active
  }
}

export const SET_INPUT_TYPE = 'SET_INPUT_TYPE';
export const setInputType = (inputtype: string) => {
  return {
    type: SET_INPUT_TYPE,
    inputtype
  }
}

export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const setSearchTerm = (term: string) => {
  return {
    type: SET_SEARCH_TERM,
    term
  }
}

export const CLEAR_SEARCH_TERM = 'CLEAR_SEARCH_TERM';
export const clearSearchTerm = () => {
  return {
    type: CLEAR_SEARCH_TERM
  }
}

export const SET_SUGGESTIONS = 'SET_SUGGESTIONS';
export const setSuggestion = (suggestionsBody: any) => {
  return {
    type: SET_SUGGESTIONS,
    suggestionsBody
  }
}

export const SET_SEARCH_RESULT = 'SET_SEARCH_RESULT';
export const setSearchResults = (searchResult: any, resultType: string) => {
  return {
    type: SET_SEARCH_RESULT,
    searchResult,
    resultType
  }
}

export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const clearSearch = () => {
  return {
    type: CLEAR_SEARCH
  }
}

export const CLEAR_RESULTS = 'CLEAR_RESULTS';
export const clearResults = () => {
  return {
    type: CLEAR_RESULTS
  }
}

export const SET_CURRENTITEM = 'SET_CURRENTITEM';
export const setCurrentItem = (current: any) => {
  return {
    type: SET_CURRENTITEM,
    currentItem: current
  }
}

export const SET_CURRENT_SEARCH_ITEM = 'SET_CURRENT_SEARCH_ITEM';
export const setCurrentSearchImage = (current: any) => {
  return {
    type: SET_CURRENT_SEARCH_ITEM,
    current
  }
}

export const CLEAR_CURRENT_SEARCH_ITEM = 'CLEAR_CURRENT_SEARCH_ITEM';
export const clearCurrentSearchImage = () => {
  return {
    type: CLEAR_CURRENT_SEARCH_ITEM
  }
}

/**
 * Get the suggestions for a specific term
 */
export const getSuggestions = (term: string) => {
  return (dispatch: any) => {
    Search.suggest(term).then((result: any) => {
      dispatch(setSuggestion(result.data));
    }).catch(err => console.log(err));
  }
}


/**
 * Get the suggestions for a specific term
 */
export const getSearchResult = (term: string, type: string) => {
  return (dispatch: any, getState: any) => {
    if (term.length > 0) {
      let alreadyFoundLength = 0;
      if (type === '') {
        alreadyFoundLength = getState().result.searchResultWeb.length;
      } else if (type === 'image') {
        alreadyFoundLength = getState().result.searchResultPhoto.length;
      } else if (type === 'video') {
        alreadyFoundLength = getState().result.searchResultVideo.length;
      }
      if (alreadyFoundLength <= 0) {
        Search.search(term, type).then((result: any) => {
          dispatch(setSearchResults(result.data, type));
        }).catch(err => console.log(err));
      }
    }
  }
}

/**
 * forward to input
 */
export const forwardToInput = () => {
  return (dispatch: any, getState: any) => {
    if (getState().result.searchType === 'text') {
      dispatch(push('/inputtext'));
    }
    if (getState().result.searchType === 'speak') {
      dispatch(push('/inputspeech'));
    }
  }
}
